// extracted by mini-css-extract-plugin
export var autoExpand = "_2w-8";
export var container = "_2w-7";
export var containerWidth = "_2w-5";
export var disabled = "_2w-2";
export var error = "_2w-3";
export var fullWidth = "_2w-6";
export var inputWrapper = "_2w-0";
export var small = "_2w-1";
export var textarea = "_2w-4";